import { render, staticRenderFns } from "./Calc.vue?vue&type=template&id=2bc4161a&scoped=true&"
import script from "./Calc.vue?vue&type=script&lang=js&"
export * from "./Calc.vue?vue&type=script&lang=js&"
import style0 from "./Calc.vue?vue&type=style&index=0&id=2bc4161a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc4161a",
  null
  
)

export default component.exports